import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export function useSiteConfig() {
  const [config, setConfig] = useState(null);
  useEffect(() => {
    axios
      .get(`${API}/site-config`)
      .then((r) => setConfig(r.data))
      .catch(() => setConfig({}));
  }, []);
  return config;
}
